//@flow
import React from "react";
import fluxfix from '../../services/fluxfix';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faVolumeUp, faVolumeMute } from "@fortawesome/free-solid-svg-icons";
//  $FlowFixMe
import css from "./ui-volume-control.module.scss";
import Store from "./../../services/store";

import { Container } from "flux/utils";

import { Actions } from "./../../services/actions";

import Slider from "react-rangeslider";

type Props = {};

type State = {
  store: Object,
  isHovered: boolean,
};

class Panel extends React.Component<Props, State> {
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return {
      store: Store.getState(),
    };
  }

  handleVolumeChange(e: number) {
    Actions.setVolume(e);
  }

  toggleMute(e) {
    e.stopPropagation();
    if (this.state.store.get("mute") === true) {
      Actions.setIsMuted(false);
    } else {
      Actions.setIsMuted(true);
    }
  }

  // onHoverStart() {
  //   this.setState({
  //     isHovered: true,
  //   });
  // }

  // onHoverEnd() {
  //   this.setState({
  //     isHovered: false,
  //   });
  // }

  handleTogglePlay(e: SyntheticMouseEvent<*>) {
    e.stopPropagation();
    Actions.togglePlay();
  }

  render() {
    // const isPlaying = this.state.store.get("isPlaying");
    // const isBuffering = this.state.store.get("isBuffering");
    // const icon = isBuffering ? <FontAwesomeIcon icon={faSync} spin={true} /> : isPlaying ? <FontAwesomeIcon icon={faPause} /> : <FontAwesomeIcon icon={faPlay} />;

    return (
      <div className={css.wrapper} 
      // onMouseLeave={() => this.onHoverEnd()}
      >
        <div className={css.volumebutton} 
        // onMouseEnter={() => this.onHoverStart()} 
        onClick={(e) => this.toggleMute(e)}>
          <FontAwesomeIcon icon={this.state.store.get("mute") === true ? faVolumeMute : faVolumeUp} />
        </div>
        <div className={css.sliderWrapper}>
          <Slider orientation="horizontal" value={this.state.store.get("volume")} onChange={(e) => this.handleVolumeChange(e)} />
        </div>
      </div>
    );
  }
}

export default (Container.create(fluxfix.convert(Panel)):Object);
